import store from "../storage/redux/store";
import {signOut} from "../components/user/userSlice";
import {addFlashMessage} from "../components/flash-message/flashMessagesSlice";
import {TYPE_ERROR} from "../components/flash-message/FlashMessages";

export default function ApiError(error) {
  if (error.response) {
    if (401 === error.response.status) {
      store.dispatch(signOut());
    } else if ([400, 403, 404].includes(error.response.status)) {
      store.dispatch(addFlashMessage({
        message: error.response.data.message,
        type: TYPE_ERROR,
      }));
    }
  } else if (error.request) {
    //console.log(error.request); // TODO: заглушка!
  } else {
    error.type = TYPE_ERROR;
    store.dispatch(addFlashMessage(error));
  }

  return false;
}
